import React, { useState } from "react";
import { Box, Button, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import "./BlogContent.scss";

const PrasadTempleContent: React.FC<any> = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Box>
      <h1>Prasad Temples – Sacred Offerings Delivered to You</h1>

      <Collapse in={expanded} collapsedSize={120}>
        <p>
          In the rhythm of devotion, Prasad is not just food or sweets, it is
          the Divine’s blessing, offered and received with humility, love and
          surrender. At Temple Dekho, we bring this divine exchange to your
          doorstep by enabling <strong>online Prasad booking</strong> at India’s
          most revered temples.
        </p>
        <p>
          Today, when time, distance or circumstance prevent a physical visit,
          Temple Dekho ensures that your act of devotion is not delayed. You can
          now connect with holy shrines, receive sacred Prasad, and immerse in
          the blessing of the Divine, even from afar.
        </p>

        <h2>What is Prasad ?</h2>
        <p>
          Prasad is the consecrated offering made to a deity, one that returns
          to the devotee imbued with divine energy. Through this ritual of
          giving and receiving, the barrier between the mortal and the divine is
          dissolved, and blessings flow into the devotee’s life. Through Temple
          Dekho, you can also explore{" "}
          <a href="/temples" className="linkedText">
            famous temples to visit in India
          </a>{" "}
          that offer Prasad and other divine experiences.
        </p>
        <p>
          With Temple Dekho, you can book Prasad services online: the temple
          priests perform the ritual, Prasad is prepared as per tradition, and
          then delivered to you or your loved ones, making sacred connection
          simple, genuine and accessible.
        </p>

        <p>
          Once the ritual is completed, the Prasad is packaged with reverence
          and dispatched, making it possible for you or your loved ones to
          receive the blessings even if distance or time prevents a physical
          visit.
        </p>

        <h2>Our Mission: Bringing Divine Grace Home</h2>
        <p>
          At Temple Dekho, our mission is to make spirituality reachable,
          whether you’re miles away from home, tied up in work, or unable to
          visit for any reason. We believe that devotion transcends distance,
          and we commit to bringing the sacred into your life through Prasad and
          ritual services. You can also <a href="/pujas">book puja online</a>{" "}
          with us and enhance your spiritual experience alongside your Prasad
          offering.
        </p>
        <p>
          By combining tradition with technology, we ensure your booking is
          secure, your offering authentic, and your experience filled with
          faith. For devotees who wish to witness rituals live, Temple Dekho
          also offers{" "}
          <a href="/livedarshan" className="linkedText">
            e darshan
          </a>{" "}
          services from various holy shrines across India.
        </p>

        <h2>How the Online Prasad Service Works</h2>
        <ol>
          <li>
            <strong>Choose the Temple</strong> – Select a temple offering
            authentic Prasad services.
          </li>
          <li>
            <strong>Select Prasad Package</strong> – Pick from sweets, bhog,
            fruits, or temple-specific items.
          </li>
          <li>
            <strong>Provide Devotee Details</strong> – Add your name, gotra, and
            any special intention.
          </li>
          <li>
            <strong>Make Payment</strong> – Complete a simple and secure online
            payment.
          </li>
          <li>
            <strong>Receive Delivery</strong> – Get ritual confirmation and have
            Prasad delivered to your home.
          </li>
        </ol>

        <h2>Why Book Prasad Online with Temple Dekho?</h2>
        <ul>
          <li>
            <strong>Authentic & Verified:</strong> Prasad is prepared and
            blessed by temple-authorized priests.
          </li>
          <li>
            <strong>Convenient & Accessible:</strong> Distance is no longer a
            barrier to devotion.
          </li>
          <li>
            <strong>Transparent Process:</strong> Clear details on rituals,
            offerings, and delivery.
          </li>
          <li>
            <strong>Spiritual Upliftment:</strong> Receiving Prasad brings
            peace, blessings and a deeper connection to the Divine. You can even
            include an <a href="/chadhavaTemples">online chadhava service</a> to
            complement your offering.
          </li>
        </ul>

        <h2>What You Can Expect</h2>
        <ul>
          <li>
            <strong>Daily Bhog Prasad:</strong> Fresh offerings prepared during
            daily worship.
          </li>
          <li>
            <strong>Special Festival Prasad:</strong> Prasad during temple
            festivals, auspicious days, or special homas.
          </li>
          <li>
            <strong>Family & Ancestor Prasad:</strong> Dedicate Prasad in honour
            of family, ancestors, or for special life events.
          </li>
          <li>
            <strong>Temple-Fund Support via Prasad:</strong> Your offering also
            sustains temple services and communal devotion.
          </li>
        </ul>

        <h2>The Temple Dekho Promise</h2>
        <p>
          Every Prasad booked through Temple Dekho is handled with reverence,
          respect and complete authenticity. We align with temple vidhi (ritual
          procedure), ensure verified priest engagement, and maintain
          transparency throughout the process. Your devotion reaches the temple
          and the blessings return to you.
        </p>

        <h2>Book Your Prasad Today</h2>
        <p>
          Let the blessings travel across time and distance. Through Temple
          Dekho’s online Prasad service, devotion reaches your home, and the
          Divine meets you where you are.
        </p>
        <p>
          Because faith should never be bound by geography, only by sincerity.
        </p>
      </Collapse>

      <Button
        variant="outlined"
        sx={{ mt: "10px" }}
        onClick={handleToggle}
        color="primary"
      >
        {expanded ? "Read Less" : t(LOCALIZATION.Read_More)}
      </Button>
    </Box>
  );
};

export default PrasadTempleContent;
